<div [@scaleIn] *ngIf="visible" class="dialog">
    <form class="row" [formGroup]="sponsorsRegisterForm" (ngSubmit)="submit()">

        <div class="form-group col-sm-12" >
            <label for="firstname">First Name </label>
            <input type="text" class="form-control" formControlName="firstname" id="firstname" placeholder="Firstname">
        </div>

        <div class="form-group col-sm-12" >
            <label for="lastname">Last Name </label>
            <input type="text" class="form-control" formControlName="lastname" id="lastname" placeholder="Lastname">
        </div>

        <div class="form-group col-sm-12" >
            <label for="email">Email Address </label>
            <input type="email" class="form-control" formControlName="email" id="email" aria-describedby="emailHelp"
                placeholder="Enter email">
        </div>

        <div class="form-group col-sm-12" >
            <label for="Cellphone">Cellphone</label>
            <input type="text" class="form-control" formControlName="cellphone" id="cellphone" placeholder="Cellphone">
        </div>

        <div class="form-group col-sm-12" >
            <label for="Password">Password</label>
            <input type="password" class="form-control" formControlName="password" id="password" placeholder="Password">
        </div>

        <div class="form-group col-sm-12" >
            <label for="Confirm Password">Confirm Password</label>
            <input type="password" class="form-control" formControlName="confPassword" id="confPassword" placeholder="Confirm Password">
        </div>

        <div class="row" *ngIf="showConfFields">
            <div class="form-group col-sm-12">
                <label for="Code">Verification Code</label>
                <input type="text" class="form-control" formControlName="code" id="code" placeholder="code">
            </div> 

        </div>

        

        <button type="submit" class="btn btn-primary m-b-1" >Register</button>
        <button  *ngIf="showConfFields" (click)="confirmSignUp()" class="btn btn-primary m-b-1" >Confirm</button>
    </form>
    <a (click)="close()"><h6 style="color: red;">X</h6></a>
    <!-- <a class="btn btn-primary m-b-1 dialog__close-btn" (click)="close()">Close</a> -->
</div>

